<navbar-component></navbar-component>

<main class="img-background">
  <div style="display: flex; flex-direction: column; min-height: 80vh">
    <div class="label-wrapper">
      <img class="label-img" src="assets/fotos/cria-head.svg" />
    </div>

    <div class="container">
      <div class="information-container">
        <div class="info_containter"></div>
      </div>

      <div class="leavings-container">
        <div class="row">
          <div class="col">
            <a href="/cria/didatica">
              <img
                class="label-img btn-menu"
                src="assets/fotos/mn-didatica.svg"
              />
            </a>
          </div>
          <div class="col">
            <a href="/cria/informacoes">
              <img class="label-img btn-menu" src="assets/fotos/mn-info.svg" />
            </a>
          </div>
          <div class="col">
            <a href="/cria/resultados">
              <img
                class="label-img btn-menu"
                src="assets/fotos/mn-resultados.svg"
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="information-container">
        <div class="information">
          <div class="information-title">
            <img
              class="label-img responsive-img"
              src="assets/fotos/cria-logo.svg"
            />
          </div>
          <div class="information-subtitle">
            Design + Economia Criativa + Economia da Cultura: uma abordagem
            estratégica de desenvolvimento
          </div>
          <div class="information-text">
            Aprovado no edital Funcultura 2019/2020 busca orientar a construção
            de negócios culturais criativos e sustentáveis por meio de uma
            abordagem, o CRIA. Ele é um programa de inteligência, organizado
            como uma rede de conhecimentos da economia criativa, gestão,
            sustentabilidade e design construído mediante processos educativos,
            diálogos e ações.
          </div>
        </div>
      </div>

      <div class="leavings-container">
        <div class="row"></div>
        <img style="width: 100%" src="assets/background/back-cria.svg" />
      </div>
    </div>
  </div>
</main>

<footer-component></footer-component>
